import 'slick-carousel';

//Init main slider
$('.js-slider-main').each(function() {
	const $this = $(this);
	const $sliderSlides = $this.find('.slider__slides')

	$sliderSlides.slick({
		slidesToShow: 1,
		sliderToScroll: 1,
		arrows: false,
		dots: true,
		autoplay: true,
		autoplaySpeed: 3000,
	})
})

//Init slider testimonials
$('.js-slider-testimonials').each(function() {
	const $this = $(this);
	const $sliderSlides = $this.find('.slider__slides')
	let slidesToShow = $this.data('slides-to-show');
	let slidesToScroll = $this.data('slides-to-scroll');

	$sliderSlides.slick({
		slidesToShow: slidesToShow,
		sliderToScroll: slidesToScroll,
		autoplay: true,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				}
			},
		],
	})
})

$('.js-slider-testimonials-type1').each(function() {
	const $this = $(this);
	const $sliderSlides = $this.find('.slider__slides')
	let slidesToShow = $this.data('slides-to-show');
	let slidesToScroll = $this.data('slides-to-scroll');

	$sliderSlides.slick({
		slidesToShow: slidesToShow,
		sliderToScroll: slidesToScroll,
		autoplay: true,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 5,
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				}
			},
			{	breakpoint: 768,
				settings: {
					slidesToShow: 2,
				}
			},
			{	breakpoint: 575,
				settings: {
					slidesToShow: 1,
				}
			},
		],
	})
})

//Init logos slider

$('.js-slider-logos').each(function() {
	const $this = $(this);
	const $sliderSlides = $this.find('.slider__slides')

	$sliderSlides.slick({
		slidesToShow: 5,
		sliderToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 1,
				}
			},
		],
	})
})

//Init slider cards
$('.js-slider-cards').each(function() {
	const $this = $(this);
	const $sliderSlides = $this.find('.slider__slides')

	$sliderSlides.slick({
		slidesToShow: 4,
		sliderToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 1,
					adaptiveHeight: true,
				}
			},
		],
	})
})

//Init slider cards
$('.js-slider-cards-2').each(function() {
	const $this = $(this);
	const $sliderSlides = $this.find('.slider__slides')

	$sliderSlides.slick({
		slidesToShow: 5,
		sliderToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 1250,
				settings: {
					slidesToShow: 4,
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 1,
					adaptiveHeight: true,
				}
			},
		],
	})
})

//Init slider members
$('.js-slider-members').each(function() {
	const $this = $(this);
	const $sliderSlides = $this.find('.slider__slides')

	$sliderSlides.slick({
		slidesToShow: 5,
		sliderToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 4,
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 1,
					adaptiveHeight: true,
				}
			},
		],
	})
})

//Init slider blog
$('.js-slider-blogs').each(function() {
	const $this = $(this);
	const $sliderSlides = $this.find('.slider__slides')
	let slidesToShow = $this.data('slides-to-show');
	let slidesToScroll = $this.data('slides-to-scroll');

	$sliderSlides.slick({
		slidesToShow: slidesToShow,
		sliderToScroll: slidesToScroll,
		autoplay: true,
		autoplaySpeed: 3000,
		dots: true,
		arrows: false,
	})
})